import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Login from "./views/Login.vue";
import Paiement from "./views/Paiement";
import Recouvrement from "./views/Recouvrement";
import Informations from "./views/Informations";
import Messages from "./views/Messages";
import Contact from "./views/Contact";
import Error404 from "./views/500Error";
import PaiementCheck from "./views/PaiementCheck";
import MentionsLegales from "./views/MentionsLegales";
import DonneesPerso from "./views/DonneesPerso";
import Modals from "./views/components/JavascriptComponents/Modals";
import Waiting from "./views/Waiting";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/modals",
      name: "Modals",
      components: {
        default: Modals
      }
    },
    {
      path: "/",
      name: "Home",
      redirect: "/login/0/0/0"
    },
    {
      path: "/off",
      name: "Maintenance",
      components: {
        default: Waiting
      }
    },
    {
      path: "/checkpaiement/:validation",
      name: "Verification Paiement",
      components: {
        header: AppHeader,
        default: PaiementCheck
      }
    },
    {
      path: "/mentionslegales",
      name: "Mention Légales",
      components: {
        default: MentionsLegales,
        footer: AppFooter
      }
    },
    {
      path: "/donneesperso",
      name: "Politique de données personnel",
      components: {
        default: DonneesPerso,
        footer: AppFooter
      }
    },
    {
      path: "/paiement",
      name: "Paiement",
      components: {
        header: AppHeader,
        default: Paiement,
        footer: AppFooter
      }
    },
    {
      path: "/contact",
      name: "Contact",
      components: {
        header: AppHeader,
        default: Contact,
        footer: AppFooter
      }
    },
    {
      path: "/recouvrement",
      name: "Recouvrement",
      components: {
        header: AppHeader,
        default: Recouvrement,
        footer: AppFooter
      }
    },
    {
      path: "/informations",
      name: "informations",
      components: {
        header: AppHeader,
        default: Informations,
        footer: AppFooter
      }
    },
    {
      path: "/messages/:type",
      name: "Messages",
      components: {
        header: AppHeader,
        default: Messages,
        footer: AppFooter
      }
    },
    {
      path: "/login/:type/:id/:pswrd",
      name: "login",
      //redirect: "/off" // REDIRECTION MAINTENANCE
      components: {
        default: Login,
        footer: AppFooter
      }
    },
    {
      path: "/404",
      name: "Error404",
      components: {
        default: Error404
      }
    },
    {
      path: "*",
      name: "404",
      redirect: "/404"
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
